import { FormNodeAttendanceTypeModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class AttendanceTypeEditor extends AbstractElementEditor<FormNodeAttendanceTypeModel> {
  public getDescription(): string {
    return 'List of products available to buy';
  }

  public getName(): string {
    return 'Product picker';
  }

  public getIcon(): string {
    return 'inventory';
  }
}
